import axios from "axios";
import { Navigate } from "react-router-dom";
import { AES, enc, pad } from 'crypto-js'


const secretKey = process.env.REACT_APP_ENCRYPTION_KEY;

const TOKEN_KEY = 'contextVar';

export const login = (props) => {
    console.log("Login called -> ", props);
    localStorage.setItem(TOKEN_KEY, 'TestLogin');

}

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    Navigate('/user-login');
}

export const isLogin = () => {
    if (localStorage.getItem(TOKEN_KEY)) {
        return true;
    }
    return false;
}

export const decryptedUserId = () => {
    if (localStorage.getItem("contextVar")) {
        var bytes = AES.decrypt(
          localStorage.getItem("contextVar").toString(),
          secretKey
        );

        if (bytes.toString(enc.Utf8)) {
          return JSON.parse(bytes.toString(enc.Utf8));
        }
    } else {
        return '';
    }
}

export const cryptedUserId = () => {
    if (localStorage.getItem("contextVar")) {
        var bytes = AES.decrypt(
          localStorage.getItem("contextVar").toString(),
          secretKey
        );

        let key = enc.Hex.parse("0123456789abcdef0123456789abcdef");
        let iv =  enc.Hex.parse("abcdef9876543210abcdef9876543210");
        
        if (bytes.toString(enc.Utf8)) {
            let msg = JSON.parse(bytes.toString(enc.Utf8)).toString();
            return AES.encrypt(msg, key, {iv:iv, padding: pad.ZeroPadding}).toString();
        }
    } else {
        return '';
    }
}


export const setUserInfoUtil = () => {
        
    return axios
            .get( process.env.REACT_APP_ENDPOINT +  '/lib/storage/content/Users.json', {
                auth: {
                    username: "cuatconference",
                    password: "relaunch",
                },
            })
            .then((res) => {
                var user  = '';
                if (localStorage.getItem("contextVar")) {
                    var bytes = AES.decrypt(
                      localStorage.getItem("contextVar").toString(),
                      secretKey
                    );
                    
                    if (bytes.toString(enc.Utf8)) {
                      let decryptedData = JSON.parse(bytes.toString(enc.Utf8));
                    
                      res.data.forEach((element) => {
                        if (decryptedData == element.uid) {
                            user = element;
                            if(!element.livepage){
                                axios.get(process.env.REACT_APP_ENDPOINT + 'server.php', {
                                    headers: { 
                                        'Authorization': 'Basic Y3VhdGNvbmZlcmVuY2U6Y3VhdGNvbmZlcmVuY2VIVEEh'
                                    },
                                    auth: {
                                        username: 'cuatconference',
                                        password: 'relaunch'
                                    },
                                    params: {
                                        localId: process.env.REACT_APP_LOCAL_ID,
                                        user: element.uid,
                                        type: 'livePageVist'
                                    }
                                })
                                .then(() => {})
                                .catch(err=>{
                                    console.log(err);
                                })
                            }
                            
                        }
                      });
                    }
                }
                return user;
            })
            .catch((err) => {
              console.log(err);
            });
}


// axios
//             .get( process.env.REACT_APP_ENDPOINT +  '/lib/storage/content/Users.json', {
//                 auth: {
//                     username: "cuatconference",
//                     password: "relaunch",
//                 },
//             })
//             .then((res) => { 
                
//                 if (localStorage.getItem("contextVar")) {
//                     var bytes = CryptoJS.AES.decrypt(
//                       localStorage.getItem("contextVar").toString(),
//                       secretKey
//                     );
          
//                     if (bytes.toString(CryptoJS.enc.Utf8)) {
//                       let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                
//                       res.data.forEach((element) => {
//                         if (decryptedData == element.uid) {
//                           setUserInfo(element);

//                           if(!element.livepage){
//                                 axios.get(process.env.REACT_APP_ENDPOINT + 'server.php', {
//                                     headers: { 
//                                         'Authorization': 'Basic Y3VhdGNvbmZlcmVuY2U6Y3VhdGNvbmZlcmVuY2VIVEEh'
//                                     },
//                                     auth: {
//                                         username: 'cuatconference',
//                                         password: 'relaunch'
//                                     },
//                                     params: {
//                                         localId: process.env.REACT_APP_LOCAL_ID,
//                                         user: element.uid,
//                                         type: 'livePageVist'
//                                     }
//                                 })
//                                 .then(() => {})
//                                 .catch(err=>{
//                                     console.log(err);
//                                 })
//                             }

//                         }
//                       });
//                     }
//                   }
//             })
//             .catch((err) => {
//               console.log(err);
//             });
        